import get from 'lodash/get';

import {
  APP_SETTINGS_VERSION_0,
  APP_SETTINGS_VERSION_1,
  APP_SETTINGS_VERSION_LATEST,
} from './constants/versions';

import { migrateToV1 } from './migrations/version-1';
import { migrateToV2 } from './migrations/version-2';

const migrations = {
  [APP_SETTINGS_VERSION_0]: migrateToV1,
  [APP_SETTINGS_VERSION_1]: migrateToV2,
};

export function migrateToLatestVersion(appSettings) {
  const version = get(appSettings, 'numbers.settingsVersion', APP_SETTINGS_VERSION_0);

  for (let v = version; v < APP_SETTINGS_VERSION_LATEST; v++) {
    appSettings = migrations[v](appSettings);
  }

  return appSettings;
}



// WEBPACK FOOTER //
// ./~/wix-vod-shared/src/app-settings/migration.js